import { Navbar } from '@workwhile/web-ui'
import { NavSection } from './NavSection'
import { CtaButtons } from './CtaButtons'
import { CompanyInfo } from './CompanyInfo'

export const SideNav = () => {
  return (
    <Navbar>
      <CompanyInfo />
      <NavSection />
      <CtaButtons />
    </Navbar>
  )
}
